document.addEventListener('DOMContentLoaded', function () {
  var triggers = document.querySelectorAll('[data-modal]');
  var modal = document.getElementById('flexi-modal');
  var modal_background = document.getElementById('flexi-modal-background');
  var modal_close = document.getElementById('flexi-modal-close');
  var modal_iframe = document.getElementById('flexi-modal-iframe');
  var modal_content = document.getElementById('flexi-modal-content');
  var page = document.getElementById('body');
  var htmlElement = document.documentElement;
  var trap = false;
  var play_in_place = document.getElementsByClassName('play-in-place');

  if (play_in_place.length) {
    initVidyard();
  }

  var focusTrap = require('focus-trap');

  if (modal) {
    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        openModal(e);
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        closeModal();
      }
    });
    modal_close.addEventListener('click', function (e) {
      closeModal();
    });
    modal_background.addEventListener('click', function (e) {
      closeModal();
    });
  }

  function openModal(theTrigger) {
    /**
     * Hide unnecessary padding
     */
    var the_video = '';
    var the_content = '';

    if (theTrigger.target) {
      the_video = theTrigger.target.getAttribute('data-video');
      the_content = theTrigger.target.getAttribute('data-content');
    } else {
      the_video = theTrigger.getAttribute('data-video');
      the_content = theTrigger.getAttribute('data-content');
    }

    if (the_video) {
      modal_iframe.classList.remove('hidden');
    }

    if (the_content) {
      modal_content.classList.remove('hidden');
    }

    modal_iframe.innerHTML = the_video;
    modal_content.innerHTML = the_content; //attempt to isolate the video URL

    var video_url = the_video.match(/\bhttps?:\/\/\S+/gi)[0];
    var video_src = false; //if we have a URL

    if (video_url) {
      video_src = video_url.includes('youtube') ? 'YouTube' : video_url.includes('vimeo') ? 'Vimeo' : ' the web'; //append a screen reader button to allow proper iframe tabbing

      modal_iframe.innerHTML = modal_iframe.innerHTML + '<a href="' + video_url + '" target="_blank" class="sr-only focus:not-sr-only">Watch on ' + video_src + '</a>';
    }

    page.style.overflow = 'hidden';
    htmlElement.style.overflow = 'hidden';
    page.classList.add('modal-open');
    modal.classList.remove('invisible');
    modal.classList.remove('opacity-0');

    if (the_video) {
      modal_iframe.focus(); //if the video is served via Vimeo

      if (video_src == 'Vimeo') {
        //initialize an API instance
        var player = new Vimeo.Player(modal_iframe); //if we have a valid player instance

        if (player) {
          //trigger it
          player.play();
        }
      } else {
        var test = modal_iframe.firstChild.src += "?enablejsapi=1&autoplay=1"; // trigger youtube video to play 
      }
    } else {
      modal_content.focus();
    }

    initVidyard();

    if (!trap) {
      trap = focusTrap.createFocusTrap(modal, {
        fallbackFocus: document.getElementsByTagName('header')[0]
      });
    }

    trap.activate();
  }

  function closeModal() {
    modal.classList.add('invisible', 'opacity-0');
    page.style.overflow = '';
    htmlElement.style.overflow = '';
    page.classList.remove('modal-open');
    modal_iframe.innerHTML = '';
    modal_content.innerHTML = '';
    modal_iframe.classList.add('hidden');
    modal_content.classList.add('hidden');

    if (trap) {
      trap.deactivate();
    }
  }

  function initVidyard() {
    //attempt to fetch all vidyard elements on the page
    var embeds = document.querySelectorAll('.vidyard-player-embed'); //this will help ensure only one vidyard script is executed per page

    var script_loaded = false; //if we have some embeds

    if (embeds.length > 0) {
      //define our observer event to fire when the element comes into view
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          //if this isn't triggered on page load
          if (entry.intersectionRatio > 0) {
            //move to easily accessible var
            var embed = entry.target; //if this element has a script in data attribute form and the script hasn't already been appended

            if (embed.hasAttribute('data-script') && !script_loaded) {
              //fetch the script src
              var src = embed.getAttribute('data-script'); //create a new script tag

              var script = document.createElement('script'); //set its src as the one from the image

              script.setAttribute('src', src); //append it to the DOM

              document.body.appendChild(script); //set this to ensure it's not duplicated

              script_loaded = true;
            }
          }
        });
      }); //loop over each embed

      embeds.forEach(function (embed) {
        //apply the observer to it
        observer.observe(embed);
      });
    }
  }
});